// src/components/Footer.js
import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css'; // We will create this file next

function Footer() {
  return (
    <footer className="footer-section">
      <div className="footer-content-wrapper">
        
        {/* --- LEFT SIDE: BRANDING --- */}
        <div className="footer-left">
          <div className="footer-branding">
            <img 
              src="/refounded-17.png" 
              alt="RefoundEd Education Reinvented" 
              className="brand-logo"
            />
          </div>
        </div>

        {/* --- VERTICAL SEPARATOR --- */}
        <div className="footer-vertical-line"></div>

        {/* --- RIGHT SIDE: CONTACT & FOLLOW --- */}
        <div className="footer-right">
          
          {/* Contact Section */}
          <div className="footer-block contact-block">
            <h3>CONTACT US</h3>
            <p><a href="mailto:info@refounded.ca" className="text-link">info@refounded.ca</a></p>
            <p className="location-text">Based in Ontario, Canada</p>
            <p className="legal-links">
              <a 
                href="https://docs.google.com/document/d/1cvex61ZBqv98UACTi7cCDE3GjuY_nILi/edit?usp=drive_link&ouid=105347652403814580551&rtpof=true&sd=true" 
                target="_blank" 
                rel="noopener noreferrer"
              >
                Privacy Policy
              </a> 
              <span className="separator">|</span>
              <a 
                href="https://docs.google.com/document/d/1KW3e5nP5n3xAFi5iBMgykfadaB_1TrSf/edit?usp=drive_link&ouid=105347652403814580551&rtpof=true&sd=true" 
                target="_blank" 
                rel="noopener noreferrer"
              >
                Terms of Use
              </a>
            </p>
          </div>

          {/* Follow Section */}
          <div className="footer-block follow-block">
            <h3>FOLLOW US</h3>
            <div className="social-icons">
              <a href="https://www.facebook.com/profile.php?id=100076126100475" target="_blank" rel="noreferrer" aria-label="Facebook" className="social-icon-link">
                <img src="/refounded-20.png" alt="Facebook" />
              </a>
              <a href="https://www.instagram.com/refoundeducation/" target="_blank" rel="noreferrer" aria-label="Instagram" className="social-icon-link">
                <img src="/refounded-21.png" alt="Instagram" />
              </a>
              <a href="https://www.youtube.com/@refoundeducation" target="_blank" rel="noreferrer" aria-label="YouTube" className="social-icon-link">
                <img src="/refounded-22.png" alt="YouTube" />
              </a>
              <a href="https://www.linkedin.com/company/refound-education-inc" target="_blank" rel="noreferrer" aria-label="LinkedIn" className="social-icon-link svg-icon">
                 <svg viewBox="0 0 24 24" aria-hidden="true" fill="currentColor">
                    <g><path d="M20.5 2h-17A1.5 1.5 0 002 3.5v17A1.5 1.5 0 003.5 22h17a1.5 1.5 0 001.5-1.5v-17A1.5 1.5 0 0020.5 2zM8 19H5v-9h3zM6.5 8.25A1.75 1.75 0 118.3 6.5a1.78 1.78 0 01-1.8 1.75zM19 19h-3v-4.74c0-1.42-.6-1.93-1.38-1.93A1.74 1.74 0 0013 14.19a.66.66 0 000 .14V19h-3v-9h2.9v1.3a3.11 3.11 0 012.7-1.4c1.55 0 3.36.86 3.36 3.66z"></path></g>
                 </svg>
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* --- FOOTER BOTTOM --- */}
      <div className="footer-bottom">
         <div className="footer-bottom-content">
             <p>© {new Date().getFullYear()} RefoundEd. All rights reserved.</p>
             <div className="footer-links">
                <Link to="/">Home</Link>
                <Link to="/listings">Listings</Link>
                <Link to="/contact">Contact</Link>
                <Link to="/signin">Login</Link>
                <a
                  href="https://form.jotform.com/231138277609056"
                  target="_blank"
                  rel="noreferrer"
                  className="donate-link"
                >
                  Donate
                </a>
             </div>
         </div>
      </div>
    </footer>
  );
}

export default Footer;